export const HOTDOGS = [
	{
		id: 0,
		name: 'Grilled Cheese Dog',
		description:
			'A combo of two favorites, the Grilled Cheese Dog is here to satisfy two cravings in one! It’s simply a hot dog sandwich with spices, shredded cheddar cheese, and green onions. Served with spicy homemade ketchup and fries.',
		price: 5.75,
		image: 'assets/images/cheese.jpg',
		food: true,
	},
	{
		id: 1,
		name: 'Jalapeño Popper Dog',
		description:
			'When you need a little heat with your meat, the Jalapeño Popper Dog comes to the rescue. It’s made up of a grilled hot dog, wrapped in American cheese and jalapeños. Served with old-world styled mustard and fries.',
		price: 6.25,
		image: 'assets/images/jalapeno-popper.jpg',
		food: true,
	},
	{
		id: 2,
		name: 'Quesadogas',
		description:
			'A cheesy Tex-Mex mashup of your dreams. This is what happens when a quesadilla and a hot dog come together in perfect harmony.  A combo of cheddar, Monterey Jack, jalapeño, green onions, and hot dogs wrapped up in a tortilla and grilled to perfection. Served with chive and sour cream guacamole and tortilla chips.',
		price: 8.25,
		image: 'assets/images/quesadogas.jpg',
		food: true,
	},
	{
		id: 3,
		name: 'Mac and Cheese Dogs',
		description:
			'For the Mac and Cheese lover, these dogs are gonna blow you away! These hot dogs are topped with our spicy Mac and cheese, bacon bits, and jalapeño. Served along wide with our southern BBQ sauce and seasoned fries.',
		price: 8.25,
		image: 'assets/images/mac-and-cheese.jpg',
		food: true,
	},
	{
		id: 4,
		name: 'Pickle Dogs',
		description:
			'No carbs? No problem! Our pickle dogs replace the buns with a juicy pickle slathered in cream cheese and mustard. Served with jicama fries seasoned with cayenne and garlic powder alongside some hot sriracha aioli.',
		price: 7.75,
		image: 'assets/images/pickle.jpg',
		food: true,
	},
	{
		id: 5,
		name: 'Pizza Dogs',
		description: 'Just when you thought you couldn’t get any meatier, BAM! These dogs are topped with mozzarella, marinara, and loads of pepperoni. Served with a Caesar side salad.',
		price: 9.25,
		image: 'assets/images/pizza.jpg',
		food: true,
	},
	{
		id: 6,
		name: 'Vegan Chicago Dogs',
		description:
			'All of your Chicago style hot dogs, without any of the meat! We use impossible dogs topped with cherry tomatoes, pickles, mustard, and shredded lettuce. Served with olive tapenade aioli and seasoned fries.',
		price: 9.25,
		image: 'assets/images/vegan.jpg',
		food: true,
	},
	{
		id: 7,
		name: 'Pigs in a Blanket',
		description: 'An all time favorite, these hot dogs are snuggled up in a warm blanket of fluffy dough,served with a sharp cheddar cheese dip and seasoned fries with chipotle aioli.',
		price: 5.25,
		image: 'assets/images/pigsinablanket.jpg',
		food: true,
	},
	{
		id: 8,
		name: 'Coke',
		description: 'A nice refreshing 20 oz. bottle of Coke.',
		price: 1.25,
		image: 'assets/images/coke.jpg',
		food: false,
	},
	{
		id: 9,
		name: 'Diet Coke',
		description: 'A nice refreshing 20 oz. bottle of Diet Coke.',
		price: 1.25,
		image: 'assets/images/diet-coke.jpg',
		food: false,
	},
	{
		id: 10,
		name: 'Sprite',
		description: 'A nice refreshing 20 oz. bottle of Sprite.',
		price: 1.25,
		image: 'assets/images/sprite.jpg',
		food: false,
	},
];
